import AdminAiScanReview from "../components/ai-scans/AdminAiScanReview";
import { useAdminAiScanReports } from "../hooks/useAdminAiScanReports";

// Reads null-safety reports only while this page is mounted.
// Keeps the nullable source, unsafe operation and failing shape together so the failure remains understandable.
// Coverage still distinguishes reviewed, weak and unreviewed features when no finding is recorded.
const AdminAiNullsScanPage = () => {
  const { reports, featureReports, issues, loading, error, refresh, available } = useAdminAiScanReports("nulls");

  return (
    <AdminAiScanReview
      scan="nulls"
      title="Nulls"
      description="Review null-safety and missing-shape risks by module, business object, surface and feature. Follow each nullable source through the unsafe operation and failing shape to its proposed guard or remediation. Finding severity and risk scores remain separate from review coverage."
      featureReviewKey="featureNulls"
      findingFields={[
        "nullableSource",
        "unsafeOperation",
        "failingShape",
        "explanation",
        "filePath",
        "line",
        "symbol",
        "remediation",
        "affectedFeatureIds",
        "canonicalKey",
      ]}
      reports={reports}
      featureReports={featureReports}
      issues={issues}
      loading={loading}
      error={error}
      available={available}
      onRefresh={refresh}
    />
  );
};

export default AdminAiNullsScanPage;
